import { render, staticRenderFns } from "./ModalLocation.vue?vue&type=template&id=2baca4ae&"
import script from "./ModalLocation.vue?vue&type=script&lang=js&"
export * from "./ModalLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports